"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const logfmt = __importStar(require("logfmt"));
function isFunction(val) {
    return (typeof val !== "string" &&
        typeof val !== "number" &&
        typeof val !== "boolean" &&
        typeof val !== "object");
}
class ConsoleLogger {
    constructor(keysvals = {}, parent) {
        this.keysvals = keysvals;
        this.parent = parent;
        this.parent = parent;
        this.keysvals = keysvals;
    }
    with(keysvals) {
        return new ConsoleLogger(keysvals, this);
    }
    data() {
        const parents = this.parent != null ? this.parent.data() : {};
        return Object.assign({}, parents, this.keysvals);
    }
    log(keysvals) {
        const data = Object.assign({}, this.data(), keysvals);
        Object.keys(data).forEach(key => {
            let value = data[key];
            if (isFunction(value)) {
                data[key] = value();
            }
        });
        console.log(logfmt.stringify(data));
    }
    debug() {
        return this.with({ level: "debug" });
    }
    info() {
        return this.with({ level: "info" });
    }
    warn() {
        return this.with({ level: "warn" });
    }
    error() {
        return this.with({ level: "error" });
    }
    crit() {
        return this.with({ level: "crit" });
    }
}
exports.ConsoleLogger = ConsoleLogger;
class BrowserLogger extends ConsoleLogger {
    // FIXME is there a way to get TS to do this automatically?
    with(keysvals) {
        return new BrowserLogger(keysvals, this);
    }
    log(keysvals) {
        const data = Object.assign({}, this.data(), keysvals);
        Object.keys(data).forEach(key => {
            let value = data[key];
            if (isFunction(value)) {
                data[key] = value();
            }
        });
        const msg = data.msg || "";
        if (data.level === "debug" || data.level === "info") {
            console.groupCollapsed(msg.toString());
        }
        else {
            console.group(msg.toString());
        }
        if (data.err) {
            console.error(data.err);
        }
        switch (data.level) {
            /*
            case "error":
            case "crit":
              console.error(data);
              break;
            case "warn":
              console.warn(data);
              break;
            case "info":
              console.info(data);
              break;
            case "info":
              console.info(data);
              break;
            case "debug":
              console.debug(data);
              break;
      */
            default:
                console.table(data);
        }
        console.groupEnd();
    }
}
exports.BrowserLogger = BrowserLogger;
class NoopLogger extends ConsoleLogger {
    log() { }
    with() {
        return this;
    }
}
exports.NoopLogger = NoopLogger;
//# sourceMappingURL=index.js.map